<mat-card-content class="nsc-card-content {{ class }}"><ng-content></ng-content></mat-card-content>
